import Vue from 'vue'
import store from '@/vuex/index.js'
import Router from 'vue-router'

// auth0
import Callback from '@/views/Callback'

// views
import Home from '@/views/Home'
import HerdProfile from '@/views/HerdProfile'
import HerdSort from '@/views/HerdSort'
import BullFinderManager from '@/views/BullFinderManager'
import FavoriteBulls from '@/views/FavoriteBulls'
import HerdSortManager from '@/views/HerdSortManager'
import UserManager from '@/views/UserManager'
import MediaManager from '@/views/MediaManager'
import BullFinder from '@/views/BullFinder'
import BbCustomerInvoices from '@/views/BbCustomerInvoices'
import HerdtraxAssistant from '@/views/HerdtraxAssistant'
import AnimalSourceManager from '@/views/AnimalSourceManager'
import AppSettings from '@/views/AppSettings'
import BullFinderLite from '@/views/BullFinderLite'
import BullFinderLiteMini from '@/views/BullFinderLiteMini'
import PhotoViewer from '@/views/PhotoViewer'
import VideoViewer from '@/views/VideoViewer'
import Help from '@/views/Help'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback,
      meta: {
        requiresAuth: false,
        parentRoute: '/'
      }
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: {
        requiresAuth: false,
        parentRoute: '/'
      }
    },
    {
      path: '/BullFinderLite',
      name: 'BullFinderLite',
      component: BullFinderLite,
      meta: {
        requiresAuth: false,
        parentRoute: '/'
      }
    },
    {
      path: '/bullFinderLiteMini',
      name: 'BullFinderLiteMini',
      component: BullFinderLiteMini,
      meta: {
        requiresAuth: false,
        parentRoute: '/'
      }
    },
    {
      path: '/photoViewer',
      name: 'PhotoViewer',
      component: PhotoViewer,
      meta: {
        requiresAuth: false,
        parentRoute: '/'
      }
    },
    {
      path: '/videoViewer',
      name: 'VideoViewer',
      component: VideoViewer,
      meta: {
        requiresAuth: false,
        parentRoute: '/'
      }
    },
    {
      path: '/herdProfile',
      name: 'HerdProfile',
      component: HerdProfile,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/herdSort',
      name: 'HerdSort',
      component: HerdSort,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/herdtraxAssistant',
      name: 'HerdtraxAssistant',
      component: HerdtraxAssistant,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/bullFinderManager/:user_id?',
      name: 'BullFinderManager',
      component: BullFinderManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/bullFinder/:user_id?',
      name: 'BullFinder',
      component: BullFinder,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/herdSortManager',
      name: 'HerdSortManager',
      component: HerdSortManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/userManager',
      name: 'UserManager',
      component: UserManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/mediaManager',
      name: 'MediaManager',
      component: MediaManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/favoriteBulls/:user_id?',
      name: 'FavoriteBulls',
      component: FavoriteBulls,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/bbCustomerInvoices',
      name: 'BbCustomerInvoices',
      component: BbCustomerInvoices,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/animalSourceManager',
      name: 'AnimalSourceManager',
      component: AnimalSourceManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/appSettings',
      name: 'AppSettings',
      component: AppSettings,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    var isAuthentcated = false
    if (store !== undefined) {
      if (store.state !== undefined) {
        isAuthentcated = store.state.authenticated
      }
    }
    if (to.path === '/' || to.path === '/callback' || isAuthentcated) {
      return next()
    }
    store.dispatch('logout', { target: to.path })
  } else {
    next() // make sure to always call next()!
  }
})

export default router
